import { IPDFDetailsResponse } from '@common/types';
import { PYTHON_BACKEND } from '@constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod, HttpStatus } from '@constants/http';

export async function fetchPDFDetails(docId: string): Promise<IPDFDetailsResponse | void> {
  const baseUrl = PYTHON_BACKEND;
  const endpoint = `documents/${docId}/${ApiEndpoint.PDFDetails}`;
  const url = `${baseUrl}/${endpoint}/`;
  const requestOptions = {
    method: HttpMethod.GET,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
  };

  try {
    const response = await fetch(url, requestOptions);
    const data = await response.json();
    if (!response.ok) {
      if (response.status === HttpStatus.InternalServerError) {
        throw new Error('[api.fetch-topics]: Internal Server Error');
      }
      if (data && data.message) {
        throw new Error(data.message);
      }
      throw new Error('[api.fetch-topics]: Something went wrong!');
    }
    return data;
  } catch (error: unknown) {
    console.error(error);
  }
}
